import React, { useState } from "react";

type MonthlyYear = {
  getYearlyDiscount: number;
  handleChildData: (data: boolean) => void;
};

const MonthlyYearComponent = ({ getYearlyDiscount, handleChildData }: MonthlyYear) => {
  //expand collapse start
  const animatedBadge = (
    <div className="flex relative overflow-hidden rounded-full p-px w-fit">
      <div className="bg-[#FBEDEC] text-red-2 relative flex z-[1] body-xs-medium px-2 py-1 rounded-full group/badge">
        <span className="break-normal text-center text-[9px] text-red-2 font-medium leading-[10px]">
          Save {getYearlyDiscount}%
        </span>
      </div>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%+4px)] aspect-square rounded-full pointer-events-none bg-beam animate-beamSpin z-[0]"></div>
    </div>
  );

  const options = ["1-Month plans", "1-Year plans"];

  const [selected, setSelected] = useState(options[0]);
  const [open, setOpen] = useState(false);

  const handleSelect = (value: string) => {
    setSelected(value);
    setOpen(false);
  };
  //expand collapse end

  return (
    <>
      <div className={"grid grid-cols-2 gap-2 lg:gap-4 lg:min-w-[504px]"}>
        {/*drop*/}
        <div className={"relative flex-1 font-jost"}>
          {/* Selected item */}
          <div
            className="border border-black/8 py-2.5 px-3 lg:px-3 lg:py-[13px] rounded-lg cursor-pointer select-none bg-white flex items-center justify-between"
            onClick={() => setOpen(!open)}>
            <div className={"text-sm lg:text-base flex items-center lg:gap-2"}>
              {selected}
              {/*{!isMonthlyView && animatedBadge}*/}
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              className={`size-5 transform transition-transform duration-200 ${open ? "rotate-180" : "rotate-0"}`}>
              <path
                d="M5 7.5L10 12.5L15 7.5"
                stroke="#898994"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          {/* Dropdown options */}
          {open && (
            <div className="absolute left-0 top-full pt-2 w-full border border-black/8 rounded-lg z-10 bg-gray-4">
              {options.map((opt, index) => (
                <div
                  key={opt}
                  onClick={() => {
                    const isMonthlyView = options[0] === opt;
                    handleSelect(opt);
                    handleChildData(isMonthlyView);
                  }}
                  className={`px-3 py-2 cursor-pointer flex items-center justify-between text-sm text-black lg:text-base`}>
                  {opt} {index === 1 && animatedBadge}
                </div>
              ))}
            </div>
          )}
        </div>
        {/*green pig*/}
        <div className={"flex items-center gap-2 bg-green-10 border border-green-4 rounded-lg py-1.5 pl-3 pr-2.5"}>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              className={"size-5"}>
              <path
                d="M12.4997 9.16718V9.17551M4.31036 6.98219C3.94486 6.70128 3.66415 6.32477 3.49925 5.8943C3.33435 5.46382 3.29168 4.99613 3.37596 4.54292C3.46024 4.08971 3.66819 3.66863 3.97683 3.32621C4.28546 2.9838 4.68276 2.73338 5.12481 2.60265C5.56686 2.47191 6.03646 2.46594 6.48169 2.58541C6.92692 2.70487 7.33046 2.94511 7.64769 3.27957C7.96492 3.61403 8.18351 4.02969 8.27928 4.48062C8.37505 4.93154 8.34428 5.40016 8.19037 5.83469M13.333 3.33384V6.50301C14.3644 7.09978 15.1496 8.04421 15.548 9.16718H16.6655C16.8865 9.16718 17.0985 9.25497 17.2548 9.41125C17.4111 9.56753 17.4989 9.77949 17.4989 10.0005V11.6672C17.4989 11.8882 17.4111 12.1002 17.2548 12.2564C17.0985 12.4127 16.8865 12.5005 16.6655 12.5005H15.5472C15.2672 13.2922 14.7914 14.0005 14.1655 14.5613V16.2505C14.1655 16.582 14.0338 16.9 13.7994 17.1344C13.565 17.3688 13.247 17.5005 12.9155 17.5005C12.584 17.5005 12.2661 17.3688 12.0316 17.1344C11.7972 16.9 11.6655 16.582 11.6655 16.2505V15.7647C11.3901 15.8108 11.1114 15.8339 10.8322 15.8338H7.49885C7.21964 15.8339 6.9409 15.8108 6.66552 15.7647V16.2505C6.66552 16.582 6.53382 16.9 6.2994 17.1344C6.06498 17.3688 5.74704 17.5005 5.41552 17.5005C5.084 17.5005 4.76606 17.3688 4.53164 17.1344C4.29722 16.9 4.16552 16.582 4.16552 16.2505V14.5613C3.41049 13.8863 2.87825 12.9979 2.63926 12.0137C2.40026 11.0295 2.46578 9.99599 2.82714 9.04986C3.1885 8.10373 3.82866 7.28965 4.66288 6.71537C5.49711 6.14108 6.48607 5.83368 7.49885 5.83384H9.58219L13.3322 3.33384H13.333Z"
                stroke="#308835"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            className={
              "text-green-11 font-medium text-[11px] leading-3.5 lg:text-[13px] lg:leading-4.5 lg:max-w-[130px] font-jost"
            }>
            Save more money with our yearly plans
          </div>
        </div>
      </div>
    </>
  );
};

export default MonthlyYearComponent;
